<button
  [disabled]="disabled"
  [ngClass]="[getButtonType(), getButtonSize()]"
  (click)="onClick()"
  class="action-button">
  <div class="action-button-content">
    <ng-content></ng-content>
  </div>
  
</button>
